import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import ModalComponent from 'components/Common/Modal';
import IntegrationButtons from 'components/Settings/Integrations/IntegrationButtons';
import integrationsCondition from 'components/Settings/Integrations/integrationsCondition';

export const wandIcon = `${import.meta.env.VITE_APP_CDNURL}/images/20231216-prospecting-icon.png`;

interface AIConnectorModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const AIConnectorModal = ({ isOpen, setIsOpen }: AIConnectorModalProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <ModalComponent maxWidth={600} isOpen={isOpen} setIsOpen={setIsOpen}>
      <h3 className='title-h5-m-bold border-bottom py-4 pl-4 pr-5 pb-3 mb-0'>
        Connect PolicyMogul to your AI assistant
      </h3>
      <div className='px-4 pt-4 pb-5'>
        <IntegrationButtons
          aiOnly
          className='integrations-buttons-list'
          onSelect={(section) =>
            navigate(`/settings/integrations/${section}?returnUrl=${encodeURIComponent(location.pathname)}`)
          }
        />
      </div>
    </ModalComponent>
  );
};

const AIConnectorButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  if (!integrationsCondition) return null;

  return (
    <>
      <button
        aria-label='Connect to your AI assistant'
        className='general-button action-state-hover border code-button main-subtle-text nowrap-item flex-centered justify-content-center'
        style={{ minWidth: '38px' }}
        onClick={() => setIsOpen(true)}
      >
        <img src={wandIcon} alt='' style={{ width: '16px', transform: 'translateY(-1px)' }} className='mr-0 mr-md-2' />
        <span className='d-none d-md-inline'>Connect to your AI assistant</span>
      </button>
      <AIConnectorModal isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};

export default AIConnectorButton;
